import Oidc from 'oidc-client';

// @const {String} projectClientId 專案的clientId
const projectClientId = process.env.VUE_APP_CLIENT_ID;

// @const {String} identityDomain 登入網域
// @const {String} identityPath 登入目錄
// @const {String} productionDomain 產品網域
// @const {String} productionPath 產品目錄
const identityDomain = process.env.VUE_APP_IDENTITY_PROVIDER_HOST || 'https://www.cmoney.tw';
const identityPath = '/identity/';
const productionDomain = process.env.VUE_APP_HOST || 'https://www.cmoney.tw';
const productionPath = process.env.VUE_APP_BASE_URL;
// @const {Object} config oidc-client 套件使用設定
const managerConfig = {
  userStore: new Oidc.WebStorageStateStore(),
  authority: identityDomain,
  client_id: projectClientId,
  redirect_uri: `${productionDomain}${productionPath}/login`,
  response_type: 'code',
  scope: 'openid nickname',
  post_logout_redirect_uri: `${productionDomain}${productionPath}/logout`,
  silent_redirect_uri: `${productionDomain}${productionPath}/refresh`,
  accessTokenExpiringNotificationTime: 10,
  automaticSilentRenew: true, // 使用 refresh_token
  filterProtocolClaims: false,
  loadUserInfo: false,
  monitorSession: false,
  metadata: {
    issuer: 'https://www.cmoney.tw',
    authorization_endpoint: `${identityDomain}${identityPath}authorize`,
    token_endpoint: `${identityDomain}${identityPath}token`,
    end_session_endpoint: `${identityDomain}${identityPath}endsession`,
    jwks_uri: `${identityDomain}${identityPath}keys/jwks`,
    check_session_iframe: `${identityDomain}${identityPath}checksession`,
  },
};

export default managerConfig;
